var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRapMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Modern-Music-Dj-Tape--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Modern Music Dj Tape Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.92 18a0.07 0.07 0 0 0 0.06 0 0.08 0.08 0 0 0 0 -0.08 3 3 0 0 1 -0.39 -3.78 0.26 0.26 0 0 0 0 -0.19 3 3 0 0 1 3.52 -3.51 0.23 0.23 0 0 0 0.18 0 3 3 0 0 1 3 -0.19 0.24 0.24 0 0 0 0.22 0 3.15 3.15 0 0 1 1.23 -0.31 0.24 0.24 0 0 0 0.26 -0.35L18 9a9 9 0 1 0 -9 9l0.92 0ZM3.5 9a0.5 0.5 0 0 1 -1 0A6.51 6.51 0 0 1 9 2.5a0.5 0.5 0 0 1 0 1A5.51 5.51 0 0 0 3.5 9ZM7 9a2 2 0 1 1 2 2 2 2 0 0 1 -2 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.87 21.27a3.89 3.89 0 0 0 0 -5.49l-4 -4a1.51 1.51 0 0 0 -2.14 0 1.14 1.14 0 0 0 -0.15 0.17 0.22 0.22 0 0 1 -0.18 0.1 0.24 0.24 0 0 1 -0.2 -0.07l-0.2 -0.2a1.51 1.51 0 0 0 -2.14 0c-0.06 0.07 -0.12 0.13 -0.17 0.2a0.25 0.25 0 0 1 -0.34 0.07 1.52 1.52 0 0 0 -2.09 2.09 0.25 0.25 0 0 1 -0.07 0.34l-0.2 0.17a1.51 1.51 0 0 0 0 2.14l2.54 2.54a0.26 0.26 0 0 1 0 0.28 0.26 0.26 0 0 1 -0.25 0.15l-0.81 -0.07A1.32 1.32 0 0 0 11.34 21a1.28 1.28 0 0 0 1 1.27c0.13 0.05 3.22 1.13 5.34 1.61a4.09 4.09 0 0 0 0.85 0.09 3.86 3.86 0 0 0 2.74 -1.14Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRapMusic);
export default ForwardRef;